import accountSettingsModule from '../accountSettingsModule';

function accountValidUsername(httpService, modalConstantsService) {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link(scope, ele, attrs, ctrl) {
      scope.usernameValidationRequestNum = 0;
      scope.onChange = function() {
        const requestNum = ++scope.usernameValidationRequestNum;
        const localIsEmpty = scope.user.username === '' || angular.isUndefined(scope.user.username);
        let localValidationMessage = '';
        let hasLocalValidationFailure = false;

        if (localIsEmpty) {
          hasLocalValidationFailure = true;
          localValidationMessage = modalConstantsService.changeUsername.error.notProvided;
        } else {
          localValidationMessage = Roblox.SignupFormValidatorGeneric.getInvalidUsernameMessage(
            scope.user.username
          );
          if (localValidationMessage !== '') {
            hasLocalValidationFailure = true;
          }
        }

        ctrl.$setValidity('validusername', !hasLocalValidationFailure);
        if (hasLocalValidationFailure) {
          ctrl.$usernameMessage = localValidationMessage;
        } else {
          ctrl.$usernameMessage = ''; // clear old username message

          const urlConfig = {
            url: `${Roblox.EnvironmentUrls.authApi}/v1/usernames/validate`
          };

          const params = {
            username: scope.user.username,
            context: 'UsernameChange'
          };

          httpService.httpGet(urlConfig, params).then(function(result) {
            if (requestNum !== scope.usernameValidationRequestNum) {
              return;
            }
            let unique = true;
            let valid = true;
            let validationMessage = '';

            if (result.code === 1) {
              unique = false;
              validationMessage = modalConstantsService.changeUsername.error.notAvailable;
            }

            if (result.code === 2) {
              valid = false;
              validationMessage = modalConstantsService.changeUsername.error.notAllowed;
            }

            ctrl.$setValidity('unique', unique);
            ctrl.$setValidity('moderated', valid);
            if (ctrl.$invalid) {
              if (validationMessage !== '') {
                ctrl.$usernameMessage = validationMessage;
              }
            } else {
              ctrl.$usernameMessage = '';
            }
          });
        }
      };
    }
  };
}

accountSettingsModule.directive('accountValidUsername', accountValidUsername);

export default accountValidUsername;
